import React, { Component } from 'react';

import Constants from '../../../Phi/Constants';

import Vaccination from '../../VaccinationContainer';
import HealthHistory from '../../HealthHistoryContainer';

import TabSelector from '../../../Components/TabSelector';

import './MedicalHistory.css';

import Loader from 'dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent';



// Constants

const tabList = [
    'VACCINATIONS',
    'HEALTH HISTORY'
];



class MedicalHistory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTab: 0
        };
    }


    // Lifecycle Methods

    render() {
        const { props, state } = this;


        return (
        <section className="hsg-medh-root">

            <TabSelector
                tabList={tabList}
                selected={state.selectedTab}
                onTabSelected={(pos) => this.onTabSelected(pos)} />

            
            {this.state.selectedTab === 0 ?
                <Vaccination />
            
            :
            
                <HealthHistory />}

        </section>);
    }


    componentDidMount() {

    }


    componentWillReceiveProps(newProps) {

    }


    // Event Listeners

    onTabSelected(pos) {
        this.setState({selectedTab: pos});
    }

}



export default MedicalHistory